import React, { FC, MouseEventHandler, ReactNode } from 'react';

import { classNames } from '../../../../util';
import { hasContent, isFunction } from '../../../../util/guards';
import s from './Button.scss';

interface Props {
  link?: string | false;
  className?: string;
  onClick?: MouseEventHandler | null | false;
  children?: ReactNode;
  primary?: boolean;
  secondary?: boolean;
  blank?: boolean;
  widget?: boolean;
  disabled?: boolean;
}

export const Button: FC<Props> = ({
  link,
  className,
  onClick,
  children,
  primary = false,
  secondary = false,
  blank = false,
  widget = false,
  ...rest
}) => {
  const classList = classNames([
    s.btn,
    primary && s.primary,
    secondary && s.secondary,
    blank && s.blank,
    widget && s.widget,
    className,
  ]);

  const handler = isFunction(onClick) ? onClick : undefined;

  if (hasContent(link)) {
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        tabIndex={0}
        href={link}
        className={classList}
        onClick={handler}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <button type="button" tabIndex={0} className={classList} onClick={handler} {...rest}>
      {children}
    </button>
  );
};
